import React from 'react';

import SettingsStore from '../../lib/settings/SettingsStore';

import {
  createI18nClient,
  II18nData,
  II18nClient,
} from '@wix/podcasts-common/dist/i18n';

import { TPAProvider } from '../context/tpa';
import { SettingsProvider } from '../context/settings';
import { ExperimentsProvider } from '../context/experiments';
import { I18nProvider } from '../context/i18n';
import { ConfigProvider } from '../context/config';

import { IExperiments } from '@wix/podcasts-common/dist/experiments';
import { ITPA } from '@wix/podcasts-common/dist/tpa';
import { ISettings } from '../../lib/settings/types';
import { IClientConfig } from '../../types/types';

interface IAppProvidersProps {
  i18n: II18nData;
  settingsStore: SettingsStore;
  experiments: IExperiments;
  tpa: ITPA;
  config: IClientConfig;
  children: JSX.Element;
}

interface IAppProvidersState {
  settings: ISettings;
}

class AppProviders extends React.Component<
  IAppProvidersProps,
  IAppProvidersState
> {
  props: IAppProvidersProps;
  state: IAppProvidersState;

  private readonly _i18nClient: II18nClient;

  private _unsubscribeSettings: Function;

  constructor(props) {
    super(props);

    this.state = {
      settings: props.settingsStore.get(),
    };

    this._i18nClient = createI18nClient(props.i18n);
  }

  componentDidMount() {
    const { settingsStore } = this.props;
    const updateSettings = () => {
      const settings = settingsStore.get();
      if (this.state.settings !== settings) {
        this.setState({ settings });
      }
    };

    this._unsubscribeSettings = settingsStore.subscribe(updateSettings);

    // https://reactjs.org/blog/2018/03/27/update-on-async-rendering.html#adding-event-listeners-or-subscriptions
    // External values could change between render and mount
    updateSettings();
  }

  componentWillUnmount() {
    this._unsubscribeSettings();
  }

  render() {
    const { experiments, tpa, config } = this.props;
    const { settings } = this.state;

    return (
      <TPAProvider value={tpa}>
        <ConfigProvider value={config}>
          <SettingsProvider value={settings}>
            <ExperimentsProvider value={experiments}>
              <I18nProvider value={this._i18nClient}>
                {this.props.children}
              </I18nProvider>
            </ExperimentsProvider>
          </SettingsProvider>
        </ConfigProvider>
      </TPAProvider>
    );
  }
}

export default AppProviders;
